<div
  class="ngx-pagination-wrapper"
  *ngIf="pagination && pagination.count > pagination.limit"
  [style.display]="config.paginationEnabled ? '' : 'none'"
>
  <div class="ngx-pagination-steps" *ngIf="pagination.offset > 0 || pagination.count >= pagination.limit">
    <pagination-template
      #paginationDirective="paginationApi"
      id="pagination-controls"
      [id]="id"
      [maxSize]="config.paginationMaxSize"
      (pageChange)="onPageChange($event)"
    >
      <ul
        class="ngx-pagination"
        role="navigation"
        [attr.aria-label]="screenReaderPaginationLabel"
        [class.responsive]="true"
      >
        <li
          class="pagination-previous"
          [class.disabled]="paginationDirective.isFirstPage()"
          *ngIf="directionLinks"
        >
          <a
            tabindex="0"
            *ngIf="1 < paginationDirective.getCurrent()"
            (keyup.enter)="paginationDirective.previous()"
            (click)="paginationDirective.previous()"
            [attr.aria-label]="previousLabel + ' ' + screenReaderPageLabel"
          >
            {{ previousLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
          </a>
          <span *ngIf="paginationDirective.isFirstPage()">
            {{ previousLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
          </span>
        </li>
        <li class="small-screen">
          {{ paginationDirective.getCurrent() }} / {{ paginationDirective.getLastPage() }}
        </li>
        <li
          [class.current]="paginationDirective.getCurrent() === page.value"
          [class.ellipsis]="page.label === '...'"
          *ngFor="let page of paginationDirective.pages"
        >
          <a
            tabindex="0"
            (keyup.enter)="paginationDirective.setCurrent(page.value)"
            (click)="paginationDirective.setCurrent(page.value)"
            *ngIf="paginationDirective.getCurrent() !== page.value"
          >
            <span class="show-for-sr">{{ screenReaderPageLabel }} </span>
            <span>{{ page.label }}</span>
          </a>
          <ng-container *ngIf="paginationDirective.getCurrent() === page.value">
            <span class="show-for-sr">{{ screenReaderCurrentLabel }} </span>
            <span>{{ page.label }}</span>
          </ng-container>
        </li>
        <li
          class="pagination-next"
          [class.disabled]="paginationDirective.isLastPage()"
          *ngIf="directionLinks"
        >
          <a
            tabindex="0"
            *ngIf="!paginationDirective.isLastPage()"
            (keyup.enter)="paginationDirective.next()"
            (click)="paginationDirective.next()"
            [attr.aria-label]="nextLabel + ' ' + screenReaderPageLabel"
          >
            {{ nextLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
          </a>
          <span *ngIf="paginationDirective.isLastPage()">
            {{ nextLabel }} <span class="show-for-sr">{{ screenReaderPageLabel }}</span>
          </span>
        </li>
      </ul>
    </pagination-template>
  </div>
  <div
    class="ngx-pagination-range"
    #paginationRange
    *ngIf="config.paginationRangeEnabled"
  >
    <div class="ngx-dropdown ngx-pagination-range-dropdown" id="rowAmount">
      <div class="ngx-btn-group">
        <div class="ngx-pagination-range-dropdown-button" (click)="showRange = !showRange">
          {{ pagination.limit }} <i class="ngx-icon ngx-icon-arrow-down"></i>
        </div>
        <ul class="ngx-menu" *ngIf="showRange">
          <li
            class="ngx-pagination-range-dropdown-button-item"
            [class.ngx-pagination-range--selected]="limit === pagination.limit"
            (click)="changeLimit(limit, false)"
            *ngFor="let limit of ranges"
          >
            <span>{{ limit }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
